<template>
    <div class="PerInfoBox">
        <el-form ref="Form" :model="Form" label-width="1rem" class="PerInfoForm">
            <div class="author">
                <el-upload
                    class="avatar-uploader"
                    :action="action"
                    accept=".jpg,.png"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess">
                    <img v-if="Form.VAvatar" :src="Form.VAvatar" class="avatar">
                    <div v-else class="avatar-uploader-icon">点击更改头像</div>
                </el-upload>
            </div>
            <el-form-item style="width: 50%;" label="用户名：">
                <el-input type="text" :disabled="disabled1" v-model="Form.VLoginname"></el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="姓名：">
                <el-input type="text" :disabled="disabled1" v-model="Form.VEmployeeName"></el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="组织机构：">
                <el-input type="text" :disabled="disabled1" v-model="Form.VDepName"></el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="角色：">
                <el-input type="text" :disabled="disabled1" v-model="Form.VRoleName"></el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="性别：">
                <el-radio :disabled="disabled" v-model="Form.VEmployeeGender" label="1">男</el-radio>
                <el-radio :disabled="disabled" v-model="Form.VEmployeeGender" label="2">女</el-radio>
            </el-form-item>
            <el-form-item style="width: 50%;" label="职业：">
                <el-input :disabled="disabled" type="text" v-model="Form.VJob"></el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="生日：">
                <el-date-picker
                    :disabled="disabled"
                    v-model="Form.VBirthday"
                    type="date">
                </el-date-picker>
            </el-form-item>
            <el-form-item style="width: 50%;" label="邮箱：">
                <el-input :disabled="disabled" type="text" v-model="Form.VEmail"></el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="城市：">
                <el-input :disabled="disabled" type="text" v-model="Form.VCity"></el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="手机号：">
                <el-input :disabled="disabled" type="text" v-model="Form.VPhoneNumber"></el-input>
            </el-form-item>
            <el-form-item style="width: 50%;" label="个性签名：">
                <el-input :disabled="disabled" type="textarea" v-model="Form.VSignature"></el-input>
            </el-form-item>
            <div class="author" style="height: 0;">
                <el-button @click="edit()" type="primary" style="margin: 0 auto;">{{text}}</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
import { getUser } from './../../../../untils/auth.js'
import CryptoJS from "@/untils/CryptoJS";
export default {
  name: 'userinfo',
    watch: {
        fileList(cur) {
            console.log(cur)
        }
    },
    data () {
        return {
            Form: {},
            disabled: true,
            disabled1: true,
            text: '编辑信息',
            fileList: [],
            action: '',
            active: 5,
        }
    },
    created() {
        this.action = window.IPConfig.IP + '/uploadImg.do'
        this.onUserInfo();
    },
    methods: {

        // 个人信息
        onUserInfo (){
          this.axios.post(window.IPConfig.IP + '/tBEmployee/queryemployeeShowInfo.do',{VUserId:JSON.parse(getUser()).principal.VUserId}).then((response) => {
              if (response.status == 200) {
                  if (response.data.status == 200) {

                    if (response.data.obj.VEmail !=null && response.data.obj.VEmail!=""){
                      response.data.obj.JVEmail =CryptoJS.decrypt(response.data.obj.VEmail)
                      if (!response.data.obj.JVEmail || response.data.obj.JVEmail.length < 6){

                      }else{
                        response.data.obj.VEmail= response.data.obj.JVEmail.replace(/(.{2}).+?(.{2}@.+\..+)/, '$1****$2');
                      }
                    }

                    if (response.data.obj.VPhoneNumber !=null && response.data.obj.VPhoneNumber !=""){
                      response.data.obj.JVPhoneNumber =CryptoJS.decrypt(response.data.obj.VPhoneNumber)
                      const cleanPhone = response.data.obj.JVPhoneNumber.replace(/\D/g, '');
                      response.data.obj.VPhoneNumber= cleanPhone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');

                    }
                      this.Form = response.data.obj
                  }
              }
          })
        },
        handleAvatarSuccess(res, file) {

            this.Form.VAvatar =  file.response.obj.vattachmentRemotePath;
            this.axios.post(window.IPConfig.IP + '/tBEmployee/updateAllById.do', this.Form).then((response) => {
                if (response.status == 200) {
                    if (response.data.status == 200) {
                      this.Form.VAvatar=file.response.url+file.response.obj.vattachmentRemotePath;
                      this.$message({
                            type: 'success',
                            message: '更改成功'
                        })
                    } else {
                        this.$message({
                            type: 'info',
                            message: '已取消更改'
                        })
                    }
                    this.disabled = true;
                    this.text = '编辑信息'
                    this.Form.VEmail = this.Form.JVEmail
                    this.Form.VPhoneNumber = this.Form.JVPhoneNumber
                }
            })
        },
        edit() {
            let _this = this;
            if (this.text == '编辑信息') {
                this.disabled = false;
                this.text = '保存信息'
                this.Form.VPhoneNumber = this.Form.JVPhoneNumber
                this.Form.VEmail = this.Form.JVEmail

            } else {
                this.$confirm('是否保存？', '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 处理编辑信息参数
                    // this.Form.VSystemId = this.$store.state.user.VSystemId;
                    // if(getUser()){
                    //   this.Form.VEmployeeId = JSON.parse(getUser()).principal.VUserId;
                    // }
                    // 保存编辑后的用户信息
                    this.axios.post(window.IPConfig.IP + '/tBEmployee/updateAllById.do', this.Form).then((response) => {
                        if (response.status == 200) {
                            if (response.data.status == 200) {
                                _this.onUserInfo();
                                this.$message({
                                    type: 'success',
                                    message: '更改成功'
                                })
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '已取消更改'
                                })
                            }
                            this.disabled = true;
                            this.text = '编辑信息'
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消更改'
                    })
                    this.disabled = true;
                    this.text = '编辑信息'
                })
            }
        }
    }
};
</script>

<style lang="stylus" scoped>
.PerInfoBox {
        border: 0.01rem solid #ccc;
        padding: 0.3rem;
    }
    .PerInfoForm {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .PerInfoForm .author {
        width: 100%;
        height: 1.6rem;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 0.3rem;
        position: relative;
    }
    .PerInfoForm .author > div {
        width: 1.2rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }
    .avatar-uploader .el-upload {
        border: 1px solid #d9d9d9;
        border-radius: 50%;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader-icon {
        font-size: 0.14rem;
        color: #fff;
        width: 0.9rem;
        height: 0.9rem;
        line-height: 0.9rem;
        text-align: center;
        background: #8c939d;
        border-radius: 50%;
    }
    .avatar {
        width: 0.9rem;
        height: 0.9rem;
        display: block;
        border-radius: 50%;
    }

</style>



// WEBPACK FOOTER //
// src/components/Personalcenter/components/my/userinfo.vue